interface setIntersectionObserverProps {
  targetElement: HTMLDivElement
  onIntersecting: () => void
}

export const setIntersectionObserver = ({ targetElement, onIntersecting }: setIntersectionObserverProps) => {
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          onIntersecting()
          observer.unobserve(targetElement)
        }
      })
    },
    { root: null, threshold: 0.5, rootMargin: `0px` },
  )

  observer.observe(targetElement)
}
